// Compiled at 2026-09-18T12:45:23.979Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import type { ValidationRules } from "@lg/shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { ProxyTargetSymbol } from "@lg/shared/for-apps";
import { Semaphore } from "@lg/shared/for-apps";
import { memoize } from "@lg/shared/for-apps";
import { NgSharedModule } from "@lg/ng-shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";
import { MatCardModule } from "@angular/material/card";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { RouterLink } from "@angular/router";
import { MatIconModule } from "@angular/material/icon";
import { GenericTableComponent } from "@lg/ng-shared";
import { MatTableModule } from "@angular/material/table";
import { MatButtonModule } from "@angular/material/button";
import { FileUploadComponent } from "@lg/ng-shared";
import { RichTextEditorComponent } from "@lg/ng-shared/components/rich-text-editor";

interface Properties {
    request: This.CustomerRequest;
    quantitiesPerItem: Record<This.CustomerOfferItem.Id, number[]>;
    offersPerItemQuantity: Map<This.CustomerOfferItem, Record<number, This.VendorOffer[]>>;
    highlightOfferId: This.VendorOffer.Id | undefined;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Orders-VendorOffersComparisonInclude',
    templateUrl: './VendorOffersComparisonInclude.html',
    styleUrls: ['./VendorOffersComparisonInclude.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgSharedModule,
        MatCardModule,
        MatSelectModule,
        MatFormFieldModule,
        RouterLink,
        MatIconModule,
        GenericTableComponent,
        MatTableModule,
        MatButtonModule,
        FileUploadComponent,
        RichTextEditorComponent
    ],
})
export class VendorOffersComparisonInclude extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Orders.VendorOffersComparisonInclude';
    $isDialog = false;
    $Modules = $Modules;
    Orders = Orders;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    @Output()
    submit = new EventEmitter<This.CustomerRequest>();
    output = {
        submit: async (data: This.CustomerRequest, followNextUserTask = true) => {
            data = (data as any)?.$clone ? (data as any).$clone() : data
            let result: any
            result = await (followNextUserTask ? Sys.Process.driveProcessAndFollowNextUserTask : Sys.Process.driveProcess)('submit', data)
            this.submit.emit(data)
            if (this.dialogData?.closeOnOutput === 'submit') { this.dialogRef?.close(data) }
            return result
        },
    };
    _DataTableBlock_columns_102 = (screen: Properties) => ['vendor', 'unitPrice', 'unitPriceReqCcy', 'deliveryTime'];
    $validators: Record<number, ValidationRules> = {
        133: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled, item, itemIndex, quantity, quantityIndex, offer, offerIndex, offerQuantity } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value === 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        },
        134: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled, item, itemIndex, quantity, quantityIndex, offer, offerIndex, offerQuantity } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value === 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        },
        137: {
            sync: [($value: any, $scope: any) => {
                const { app, screen, $pathSegments, $disabled, item, itemIndex, quantity, quantityIndex, offer, offerIndex } = $scope

                if ($value?.[BoInfoSymbol]?.boType == 'StaticEntity') {
                    if ($value.id) return undefined
                } else {
                    if ($value) return undefined
                    if ($value === 0) return undefined
                }
                return {
                    error: Common.$T.validationRequired,
                    ruleId: 'isRequired',
                }

            }],
            async: [],
        }
    };
    input_request = input(undefined, { alias: 'request' });
    var_request = proxySignal<This.CustomerRequest>(undefined as any);
    var_quantitiesPerItem = proxySignal<Record<This.CustomerOfferItem.Id, number[]>>(undefined as any);
    var_offersPerItemQuantity = proxySignal<Map<This.CustomerOfferItem, Record<number, This.VendorOffer[]>>>(undefined as any);
    input_highlightOfferId = input(undefined, { alias: 'highlightOfferId' });
    var_highlightOfferId = proxySignal<This.VendorOffer.Id | undefined>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get request() { return component.var_request() },
                set request(value: This.CustomerRequest) { component.var_request.set(value) },
                get quantitiesPerItem() { return component.var_quantitiesPerItem() },
                set quantitiesPerItem(value: Record<This.CustomerOfferItem.Id, number[]>) { component.var_quantitiesPerItem.set(value) },
                get offersPerItemQuantity() { return component.var_offersPerItemQuantity() },
                set offersPerItemQuantity(value: Map<This.CustomerOfferItem, Record<number, This.VendorOffer[]>>) { component.var_offersPerItemQuantity.set(value) },
                get highlightOfferId() { return component.var_highlightOfferId() },
                set highlightOfferId(value: This.VendorOffer.Id | undefined) { component.var_highlightOfferId.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            request: this.screen.request,
            highlightOfferId: this.screen.highlightOfferId
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_request = this.dialogData?.data?.request ?? this.input_request() ?? (undefined)
            if (new_request !== undefined) this.screen.request = new_request

            if (!isVariablesInitialized) this.screen.quantitiesPerItem = ({})
            if (!isVariablesInitialized) this.screen.offersPerItemQuantity = (new Map)

            const new_highlightOfferId = this.dialogData?.data?.highlightOfferId ?? this.input_highlightOfferId() ?? (undefined)
            if (new_highlightOfferId !== undefined) this.screen.highlightOfferId = new_highlightOfferId

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async handler_DropdownBlock_144_selectionChange_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {
            let selection: any = $event?.value
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    // Do currency conversion for all offered items and quantities
                    for (const vendorOffer of screen.request.vendorOffers) {
                        for (const item of vendorOffer.items) {
                            for (const quantity of item.quantities) {
                                quantity.unitPriceCustomerCcy = This.ExchangeRate.convert(quantity.unitPriceDiscounted, vendorOffer.currency, screen.request.customerOffer.currency)
                            }
                        }
                    }
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_LinkBlock_142_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    for (const offerItem of screen.request.customerOffer.items) {
                        for (const quantity of offerItem.quantities) {
                            quantity.margin = Sys.Math.roundToDigits(screen.request.customerOffer.targetMarginPercentage / 100 * quantity.bestVendorOfferQuantity?.unitPriceCustomerCcy, 2)
                            quantity.unitPrice = Sys.Math.roundToDigits(quantity.bestVendorOfferQuantity?.unitPriceCustomerCcy + quantity.margin, 2)
                        }
                    }
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_LinkBlock_184_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    for (const offerItem of screen.request.customerOffer.items) {
                        for (const quantity of offerItem.quantities) {
                            quantity.deliveryTimeWeeks = screen.request.customerOffer.targetDeliveryTimeWeeks
                        }
                    }
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    _DataTableBlock_collectionCodeSignal_102(component: any, $scope: any): any {

        return this.getMemoizedSignal(component, 'collectionCode', () =>
            computed(() => {
                let { app, screen, $pathSegments, $disabled, item, itemIndex, quantity, quantityIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.CustomerOfferItem, itemIndex: number, quantity: This.CustomerOfferItemQuantity, quantityIndex: number } = $scope ?? {}
                return (screen.offersPerItemQuantity.get(item)?.[quantity.quantity])
            }, { equal: () => false })
        )

    }

    _DataTableBlock_additionalFindOptions_102($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, itemIndex, quantity, quantityIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.CustomerOfferItem, itemIndex: number, quantity: This.CustomerOfferItemQuantity, quantityIndex: number } = $scope ?? {}

        return ({})
    }

    _DataTableBlock_rowStyle_102(θitem: This.VendorOffer, $scope: any): string {
        let { app, screen, $pathSegments, $disabled, item, itemIndex, quantity, quantityIndex, offer, offerIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.CustomerOfferItem, itemIndex: number, quantity: This.CustomerOfferItemQuantity, quantityIndex: number, offer: This.VendorOffer, offerIndex: number } = $scope ?? {}

        offer = θitem
        const θstyles: string[] = []
        θstyles.push(`background-color: ${offer.id == screen.highlightOfferId ? 'gainsboro' : ''};`)
        return θstyles.join(' ')
    }

    _DataTableColumnBlock_cellText_107($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, itemIndex, quantity, quantityIndex, offer, offerIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.CustomerOfferItem, itemIndex: number, quantity: This.CustomerOfferItemQuantity, quantityIndex: number, offer: This.VendorOffer, offerIndex: number } = $scope ?? {}

        return (offer.vendor.name)
    }

    _ScopeBlock_var_offerQuantity_153($scope: any): This.VendorOfferItemQuantity {
        let { app, screen, $pathSegments, $disabled, item, itemIndex, quantity, quantityIndex, offer, offerIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.CustomerOfferItem, itemIndex: number, quantity: This.CustomerOfferItemQuantity, quantityIndex: number, offer: This.VendorOffer, offerIndex: number } = $scope ?? {}

        const memoizedFn = memoize($scope, () => {
            return (
                offer.getItemForReqItem(item.requestItemId)?.getQuantity(quantity.quantity)
            )
        })
        return memoizedFn()
    }

    _ScopeBlock_var_offerQuantity_140($scope: any): This.VendorOfferItemQuantity {
        let { app, screen, $pathSegments, $disabled, item, itemIndex, quantity, quantityIndex, offer, offerIndex }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.CustomerOfferItem, itemIndex: number, quantity: This.CustomerOfferItemQuantity, quantityIndex: number, offer: This.VendorOffer, offerIndex: number } = $scope ?? {}

        const memoizedFn = memoize($scope, () => {
            return (
                offer.getItemForReqItem(item.requestItemId)?.getQuantity(quantity.quantity)
            )
        })
        return memoizedFn()
    }

    async handler_InputBlock_133_ngModelChange_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { item, itemIndex, quantity, quantityIndex, offer, offerIndex, offerQuantity, $disabled }: { item: This.CustomerOfferItem, itemIndex: number, quantity: This.CustomerOfferItemQuantity, quantityIndex: number, offer: This.VendorOffer, offerIndex: number, offerQuantity: This.VendorOfferItemQuantity, $disabled: any } = $scope ?? {}

        {
            let value: any = $event
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    quantity.unitPrice = Sys.Math.roundToDigits(quantity.bestVendorOfferQuantity?.unitPriceCustomerCcy + quantity.margin, 2)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_InputBlock_134_ngModelChange_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { item, itemIndex, quantity, quantityIndex, offer, offerIndex, offerQuantity, $disabled }: { item: This.CustomerOfferItem, itemIndex: number, quantity: This.CustomerOfferItemQuantity, quantityIndex: number, offer: This.VendorOffer, offerIndex: number, offerQuantity: This.VendorOfferItemQuantity, $disabled: any } = $scope ?? {}

        {
            let value: any = $event
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    quantity.margin = Sys.Math.roundToDigits(quantity.unitPrice - quantity.bestVendorOfferQuantity?.unitPriceCustomerCcy, 2)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_FileUploadBlock_177_filesSelected_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {
            let files: File[] = [...$event]
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.request.customerOffer.offerFilename = files[0].name
                    screen.request.customerOffer.offerFile = new System.BinaryData({
                        data: await files[0].arrayBuffer()
                    })
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_LinkBlock_189_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    screen.request.customerOffer.offerFile = null
                    screen.request.customerOffer.offerFilename = ''
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            for (const item of screen.request.customerOffer?.items ?? []) {
                const allQuantities = screen.request.vendorOffers.flatMap(offer =>
                    (offer.getItemForReqItem(item.requestItemId)?.quantities ?? [])
                        .filter(quantity => quantity.quantity && quantity.unitPriceDiscounted)
                        .map(({ quantity }) => quantity)
                )
                const quantities = screen.quantitiesPerItem[item.id] = Array.from(new Set(allQuantities))

                const perQuantity: Record<number, This.VendorOffer[]> = {}
                screen.offersPerItemQuantity.set(item, perQuantity)
                for (const quantity of quantities) {

                    const sortedOffers = screen.request.vendorOffers.flatMap(offer => offer.items.map(offerItem => ({ offer, offerItem })))
                        .filter(({ offerItem }) => offerItem.requestItemId == item.requestItemId && offerItem.getQuantity(quantity))
                        .sort((a, b) => a.offerItem.getQuantity(quantity)?.unitPriceCustomerCcy - b.offerItem.getQuantity(quantity)?.unitPriceCustomerCcy)
                        .map(({ offer }) => offer)
                    perQuantity[quantity] = sortedOffers
                }
            }

        }
    }
}
